/**
 */

import {
  all, call, put, takeEvery, select
} from 'redux-saga/effects';
import { productSearch } from 'api/products';
import { createPodbor } from 'api/podbors'
import { normalize } from 'normalizr';

import { SET_CURRENT_REGION_ID } from 'containers/App/constants';
import { apiRequest } from 'containers/App/saga';
import { makeSelectPageData } from 'containers/App/selectors'

import { setEntities } from 'models/actions';
import { setPageData } from 'containers/App/actions';
import { change, formValueSelector, untouch } from 'redux-form/immutable';

import { SubmissionError } from 'redux-form/immutable';
import { formatErrors, errorHandler } from 'helpers';
import { partsPageNoneFound, submitPodborMetrics, submitPodborSuccessMetrics } from 'containers/App/metricsActions'

import { Product } from '../../models';
import { PARTS_SEARCH, ADD_TO_PODBOR, CREATE_PODBOR } from './constants';



export function * productSearchGen (action) {
  const { payload: { data, resolve, reject } } = action;
  // console.log(data)
  const { podbor } = yield select(makeSelectPageData('parts'))
  yield put(setPageData({ page: 'parts', name: 'status', value: 'loading' }));
  yield put(setPageData({ page: 'parts', name: 'number', value: data.query }));
  try {
    const product = yield call(apiRequest, productSearch, data.query);
    const normalizedEntities = normalize(product, Product);
    // console.log(normalizedEntities)
    yield put(setEntities(normalizedEntities));
    yield put(setPageData({ page: 'parts', name: 'status', value: 'finished' }));
    yield put(setPageData({ page: 'parts', name: 'number', value: product.id }));
    resolve(product.id);
  } catch (e) {
    if(e.status === 404) {
      yield put(partsPageNoneFound(data.query))
    }
    // const errors = formatErrors(e);
    // const formError = new SubmissionError(errors);
    // if(!podbor) {
    //   yield put(setPageData({ page: 'parts', name: 'podbor', value: 'prepodbor' }));
    // } else {
    //   if (podbor === 'podbor') {
    //     yield put(change('parts-form', 'query', ''));
    //     yield put(untouch('parts-form', 'query'))
    //   }
    // }

    yield put(setPageData({ page: 'parts', name: 'status', value: 'finished' }));
    reject(data.query);
    // reject(formError);
  }
}

export function * addToPodborGen (action) {
  const { item } = action;
  if (!item.replace(/[\s\-]/g, '')) return
  let oldVal = yield select((state) => formValueSelector('parts-podbor')(state, 'parts'))
  oldVal = oldVal && (oldVal.toJS && oldVal.toJS() || oldVal) || []
  // console.log(oldVal)
  if(oldVal.includes(item)) {
    yield put(change('parts-podbor', 'parts', oldVal));
    // return
  } else {
    yield put(change('parts-podbor', 'parts', oldVal.concat([item])));
  }

  try {

  } catch (e) {

  }
}

export function * nullifyPodbor() {
  yield put(change('parts-podbor', 'parts', []));

  // body...
}


export function * createPodborGen(action) {
  const { payload: { data, resolve, reject }} = action

  try {
    yield put(submitPodborMetrics(data.parts))
    const result = yield call(apiRequest, createPodbor, data);
    yield put(submitPodborSuccessMetrics(data.parts))
    resolve(result)
  } catch (e) {
    errorHandler(e);
    const errors = formatErrors(e);
    const formError = new SubmissionError(errors);
    reject(formError);
  }
}


export function * resetSearchFormDealerIdGen (actions) {
  yield put(change('parts-form', 'dealerId', null));
}

export default function * rootSaga () {
  yield all([
    takeEvery(PARTS_SEARCH, productSearchGen),
    takeEvery(ADD_TO_PODBOR, addToPodborGen),
    takeEvery(CREATE_PODBOR, createPodborGen),
    takeEvery(SET_CURRENT_REGION_ID, resetSearchFormDealerIdGen),
  ]);
}
